exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".debug[data-v-7bf040c7]{padding:10px;outline:1px dashed grey}.debug__title[data-v-7bf040c7]{padding-bottom:10px}.debug__status[data-v-7bf040c7]{color:#fa314a;font-weight:700}", ""]);

